"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9733],{

/***/ 9733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "GarageProfileRatings": function() { return /* binding */ GarageProfileRatings; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/GarageProfile/GaragProfileParts/GarageProfileRatingContent.tsx


var GarageProfileRatingContent = function(props) {
    var ref = (0,react.useState)(true), isReadMore = ref[0], setIsReadMore = ref[1];
    var toggleReadMore = function() {
        setIsReadMore(!isReadMore);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        className: "text-base leading-6 font-normal text-gray-700 mb-2",
        children: [
            props.text.length > 350 && isReadMore ? props.text.slice(0, 300) + "..." : props.text,
            props.text.length > 350 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                onClick: toggleReadMore,
                className: "read-or-hide block font-bold cursor-pointer",
                children: isReadMore ? "mehr lesen" : " weniger anzeigen"
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@eo-locale/react/lib/index.js + 1 modules
var lib = __webpack_require__(7245);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 27 modules
var format = __webpack_require__(8085);
;// CONCATENATED MODULE: ./public/assets/images/repareoshortlogo.svg
/* harmony default export */ var repareoshortlogo = ({"src":"/_next/static/media/repareoshortlogo.311936a2.svg","height":16,"width":11});
;// CONCATENATED MODULE: ./components/GarageProfile/GaragProfileParts/GarageProfileRatings.tsx






var GarageProfileRatings = /*#__PURE__*/ react.memo(function(param) {
    var ratingCount = param.ratingCount, averageRating = param.averageRating, garageName = param.garageName, ratings = param.ratings;
    var daysAgo = function daysAgo(date) {
        var now = Date.now();
        var then = new Date(date);
        var timeDifference = now - then.getTime();
        var dayDifference = timeDifference / (1000 * 3600 * 24);
        return Math.round(dayDifference);
    };
    var ref;
    var itemsToShow = 3;
    var ref1 = (0,react.useState)(itemsToShow), next = ref1[0], setNext = ref1[1];
    var displayMoreItems = function() {
        setNext(next + itemsToShow);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "reviews",
        className: "col-span-full mb-16",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                className: "text-3xl font-serif text-gray-900 font-semibold",
                children: [
                    ratingCount,
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* Text */.xv, {
                        id: "ratings"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-xl leading-7 font-serif text-gray-700 mb-6",
                children: garageName
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "text-base leading-6 font-normal text-gray-900",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                        children: [
                            averageRating,
                            "%"
                        ]
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* Text */.xv, {
                        id: "recommendation"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "text-base leading-6 font-bold text-gray-900 flex items-center mt-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "star-rating-".concat((Math.round(averageRating / 100 * 5 * 2) / 2).toFixed(1).split(".").join(""), " !w-[104px] !h-[16px] inline-block mr-3")
                    }),
                    (averageRating / 100 * 5).toFixed(1),
                    " von 5"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex mb-4 mt-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "grow-0 mr-2",
                        dangerouslySetInnerHTML: {
                            __html: "5&nbsp;Sterne"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "grow-1 w-full bg-gray-200 rounded-md",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "rounded-md bg-yellow-500 block h-full",
                            style: {
                                width: "".concat(ratings === null || ratings === void 0 ? void 0 : ratings.distribution.five.toFixed(), "%")
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "grow-0 ml-2 min-w-[34px] text-right",
                        dangerouslySetInnerHTML: {
                            __html: "".concat(ratings === null || ratings === void 0 ? void 0 : ratings.distribution.five.toFixed(), "&nbsp;%")
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex mb-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "grow-0 mr-2",
                        dangerouslySetInnerHTML: {
                            __html: "4&nbsp;Sterne"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "grow-1 w-full bg-gray-200 rounded-md",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "rounded-md bg-yellow-500 block h-full",
                            style: {
                                width: "".concat(ratings === null || ratings === void 0 ? void 0 : ratings.distribution.four.toFixed(), "%")
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "grow-0 ml-2 min-w-[34px] text-right",
                        dangerouslySetInnerHTML: {
                            __html: "".concat(ratings === null || ratings === void 0 ? void 0 : ratings.distribution.four.toFixed(), "&nbsp;%")
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex mb-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "grow-0 mr-2",
                        dangerouslySetInnerHTML: {
                            __html: "3&nbsp;Sterne"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "grow-1 w-full bg-gray-200 rounded-md",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "rounded-md bg-yellow-500 block h-full",
                            style: {
                                width: "".concat(ratings === null || ratings === void 0 ? void 0 : ratings.distribution.three.toFixed(), "%")
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "grow-0 ml-2 min-w-[34px] text-right",
                        dangerouslySetInnerHTML: {
                            __html: "".concat(ratings === null || ratings === void 0 ? void 0 : ratings.distribution.three.toFixed(), "&nbsp;%")
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex mb-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "grow-0 mr-2",
                        dangerouslySetInnerHTML: {
                            __html: "2&nbsp;Sterne"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "grow-1 w-full bg-gray-200 rounded-md",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "rounded-md bg-yellow-500 block h-full",
                            style: {
                                width: "".concat(ratings === null || ratings === void 0 ? void 0 : ratings.distribution.two.toFixed(), "%")
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "grow-0 ml-2 min-w-[34px] text-right",
                        dangerouslySetInnerHTML: {
                            __html: "".concat(ratings === null || ratings === void 0 ? void 0 : ratings.distribution.two.toFixed(), "&nbsp;%")
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex mb-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "grow-0 mr-2",
                        dangerouslySetInnerHTML: {
                            __html: "1&nbsp;Sterne"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "grow-1 w-full bg-gray-200 rounded-md",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "rounded-md bg-yellow-500 block h-full",
                            style: {
                                width: "".concat(ratings === null || ratings === void 0 ? void 0 : ratings.distribution.one.toFixed(), "%")
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "grow-0 ml-2 min-w-[34px] text-right",
                        dangerouslySetInnerHTML: {
                            __html: "".concat(ratings === null || ratings === void 0 ? void 0 : ratings.distribution.one.toFixed(), "&nbsp;%")
                        }
                    })
                ]
            }),
            ratings && ((ref = ratings.data.slice(0, next)) === null || ref === void 0 ? void 0 : ref.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "rating p-4 rounded-md border border-gray-200 mb-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mb-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "star-rating-".concat((Math.round(item.rating / 100 * 5 * 2) / 2).toFixed(1).split(".").join(""), " !w-[104px] !h-[16px] inline-block mr-3")
                                }),
                                daysAgo(item.published_at) < 31 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "inline-block float-right text-base leading-6 font-normal text-gray-500",
                                    children: [
                                        " vor ",
                                        daysAgo(item.published_at),
                                        " Tagen"
                                    ]
                                }),
                                daysAgo(item.published_at) > 30 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "inline-block float-right text-base leading-6 font-normal text-gray-500",
                                    children: (0,format/* default */.Z)(new Date(item.published_at), "dd.MM.yyyy")
                                })
                            ]
                        }),
                        item.comment && /*#__PURE__*/ (0,jsx_runtime.jsx)(GarageProfileRatingContent, {
                            text: item.comment
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-base leading-6 font-bold",
                                    children: item.author
                                }),
                                item.is_verified && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "text-base leading-6 font-normal flex items-center text-gray-500 ml-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-2xl",
                                            children: "\xb7"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
                                            className: "inline-block ml-2 mr-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: repareoshortlogo.src,
                                                alt: "repareo.de Werkstattvergleich und Werkstattportal"
                                            })
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* Text */.xv, {
                                            id: "repareo_customer"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }, index);
            })),
            ratings && next < (ratings === null || ratings === void 0 ? void 0 : ratings.data.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "text-base leading-6 font-medium text-gray-700 rounded-md border border-gray-200 p-2 mb-4",
                onClick: displayMoreItems,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* Text */.xv, {
                    id: "show_more_ratings"
                })
            })
        ]
    });
});
GarageProfileRatings.displayName = "GarageProfileRatings";


/***/ })

}]);